export default "__VITE_ASSET__DoGDk7Rs__"